import React from 'react'
import { useEffect } from 'react'
import '../Lavado/lavado.css'
import './nuevo-cotizador.css'
import homeTexts from '.././utils/Texts/homeTexts.json'
import { useLangContext } from '../../Context/LangContext'
import ProductMenu from '../utils/ProductMenu/ProductMenu'
import productTexts from '../utils/Texts/productText.json'
import { isMobileOnly } from 'react-device-detect';



const NuevoCotizadorAlquiler = () => {
  const { selectedLanguage } = useLangContext()
  const text = homeTexts[selectedLanguage]
  const productText = productTexts[selectedLanguage]

  useEffect(() => {
    const alreadyInitialized = document.getElementById('rental_widget_script')
    if (alreadyInitialized) return

    const script = document.createElement('script')
    script.id = 'rental_widget_script'
    script.type = 'module'
    script.innerHTML = `
      import { RentalGuaranteeWidget } from "https://widgets.winse.online/winse_integration_worker.js";
      if (!window.__rentalWidgetLoaded) {
        const widgetInstance = new RentalGuaranteeWidget('widget_container', 'efcb815e-bdf9-4c3b-8283-4e9d8b2cc9b8');
        widgetInstance.init();
        window.__rentalWidgetLoaded = true;
      }
    `
    document.body.appendChild(script)

    return () => {
      const existingScript = document.getElementById('rental_widget_script')
      if (existingScript) {
        existingScript.remove()
        delete window.__rentalWidgetLoaded
      }
      const container = document.getElementById('widget_container')
      if (container) {
        container.innerHTML = ''
      }
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
    
    <div className="widget-background">
      <div className="widget-content">
        <div className="widget-box">
           {isMobileOnly ? "" : 
            
          <ProductMenu
            category1={productText.productMenu.category1}
            category2={productText.productMenu.category2}
            category3={productText.productMenu.category3}
            category4={productText.productMenu.category4}
            category5={productText.productMenu.category5}
            category6={productText.productMenu.category6}
            category7={productText.productMenu.category7}
            category8={productText.productMenu.category8}
            category9={productText.productMenu.category9}
            ejecutarClass={
              selectedLanguage === 'EN' ? 'display-none' : 'menu-link'
            }
          />
        }                     
          <div className="fraud-title">
            <h5 className="title-rent">
              {text.productButton}
            </h5>
          </div>
          <div className="widget-text">
            <div id="widget_container" />
          </div>
        </div>
      </div>
    </div>
   
      </>
  )
}

export default NuevoCotizadorAlquiler
